import { render } from "./Werkwijze.vue?vue&type=template&id=c64f6158&scoped=true&ts=true"
import script from "./Werkwijze.vue?vue&type=script&lang=ts"
export * from "./Werkwijze.vue?vue&type=script&lang=ts"

import "./Werkwijze.vue?vue&type=style&index=0&id=c64f6158&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64f6158"]])

export default __exports__